import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { BoReference } from './bo-reference.js'

@jsonClass('Role')
export class Role extends BusinessObject {
	@jsonArrayProperty(BoReference)
	childRoles: BoReference[] = []

	@jsonArrayProperty(BoReference)
	permissions: BoReference[] = []

	constructor(init?: Partial<Role>) {
		super()
		assignCommonProperties(this, init)
	}
}
